export default {
  dialogTitle: "新建画布",
  canvasOptions: "画布选项",
  canvasInfo: "画布信息",
  canvasType: {
    label: "画布类型",
    placeholder: "请选择画布类型",
    multiCurrency: "多币种画布",
    singleCurrency: "单币种画布",
    solana: "solana画布",
    tooltip:
      "多币种画布:支持Ethereum、BSC、Tron三条公链数据的多链多币种同画布分析，同时提供最全面的辅助分析功能\nsolana画布:solana公链数据的画布分析\n单币种画布：单链、单币种、单地址画布分析",
  },
  address: {
    label: "分析地址",
    labelWithHash: "分析地址/哈希",
    placeholder: "请输入地址或哈希",
  },
  currency: {
    label: "币种类型",
    placeholder: "请选择币种",
  },
  canvasName: {
    label: "画布名称",
    placeholder: "请输入画布名称(必填)",
  },
  canvasDescription: {
    label: "画布描述",
    placeholder: "请输入画布描述（200字以内）",
  },
  buttons: {
    reset: "重置",
    create: "新建",
  },
  validation: {
    canvasTypeRequired: "请选择画布类型",
    canvasConfigRequired: "请选择画布配置",
    currencyRequired: "请选择币种",
    addressRequired: "请输入地址",
    canvasNameRequired: "案件名称为必填项",
  },
};
